import { lazy } from 'react'
import Home from '@pages/home'
import Menu from '@pages/menu'
import Orders from '@pages/orders'
import Store from '@pages/store'
import StoreCitys from '@pages/storeCitys'
import BuyTogetherCart from '@pages/buyTogetherCart'
import Checkout from '@pages/checkout'
import PosCheckout from '@pages/posCheckout'
import Bill from '@pages/bill'
import BillTogether from '@pages/bill/buyTogether'
import Modifier from '@pages/detail/page/Modifier'
import Detail from '@pages/detail'
import Refund from '@pages/refund/refundRequest'
import RefundDetail from '@pages/refund/refundDetail'

// 支付
import Pay from '@pages/pay'
import Result from '@pages/result'
import PayPalReturn from '@pages/pay/PayPalReturn'
import MergeQr from '@pages/pay/MergeQr'
import MergeQrV2 from '@pages/pay/MergeQrV2'

// 三方券
import ThirdCoupon from '@pages/thirdCoupon'

// 会员中心
import My from '@pages/mkt/my/my'
import MySetting from '@pages/mkt/my/setting'
import MyCouponGet from '@pages/mkt/my/couponGet'
import MyOthersBind from '@pages/mkt/my/othersBind'
import MyLanguage from '@pages/mkt/my/language'
import MyResetPwd from '@pages/mkt/my/resetPwd'
import MyAddress from '@pages/mkt/my/address'

// 商城
import Mall from '@pages/mall/mall'
import MallProduct from '@pages/mall/product'
import MallCheckout from '@pages/mall/checkout'
import MallCollect from '@pages/mall/collect'
import MallPayFail from '@pages/mall/payfail'
import MallSearch from '@pages/mall/search'

// 绑定手机号或邮箱
import IBind from '@pages/mkt/iBind/bind'

// 我的会员卡
import MyCard from '@pages/mkt/iCard/card'
import MyCardRecharge from '@pages/mkt/iCard/cardRecharge'
import MyCardOpen from '@pages/mkt/iCard/cardOpen'
import MyCardApply from '@pages/mkt/iCard/cardApply'

// 我的礼品卡
import MyGiftCard from '@pages/mkt/iGc/giftCard'
import MyGiftCardDetail from '@pages/mkt/iGc/giftCardDetail'
import MyGiftCardRecharge from '@pages/mkt/iGc/recharge'
import MyGiftCardRecord from '@pages/mkt/iGc/giftRecord'
import MyGiftAvailable from '@pages/mkt/iGc/giftAvailable'

// 登录
import Login from '@pages/mkt/login/login'
import LoginVerify from '@pages/mkt/login/verify'
import LoginPassword from '@pages/mkt/login/password'

// 礼品卡
import GiftCard from '@pages/mkt/giftCard/giftCard'
import GiftCardBuy from '@pages/mkt/giftCard/buy'
import AllGiftCard from '@pages/mkt/iGc/allGiftCard'

// 券
import Coupon from '@pages/mkt/iCoupon/coupon'
import CouponRecord from '@pages/mkt/iCoupon/record'
import CouponGiftRecord from '@pages/mkt/iCoupon/giftRecord'
import GiftRecordDetail from '@pages/mkt/iCoupon/giftRecordDetail'
import CouponGetRecord from '@pages/mkt/iCoupon/couponGetRecord'
import CouponGive from '@pages/mkt/iCoupon/couponGive'

// 集点卡
import PointCard from '@pages/mkt/iPointCard/list'
import PointCardDetail from '@pages/mkt/iPointCard/detail'

// 记录（消费记录及流水）
import RecordFlow from '@pages/mkt/record/flow'
import ConsumRecord from '@pages/mkt/record/consum'
import Payfail from '@pages/payfail'
import PosPayfail from '@pages/posPayfail'

// 结果页
import MktSuccResult from '@pages/mkt/result/success'
import PaySuccess from '@pages/mkt/result/paySuccess'
import Advert from '@pages/advert/index'

// 推荐商品
import Recommend from '@pages/recommend/index'

// 活动页
import CodeCoupons from '@pages/mkt/activity/codeCoupons'
import WechatCoupons from '@pages/mkt/activity/wechatCoupons'
import CouponsSend from '@pages/mkt/activity/invitationCoupons/couponsSend'
import CouponsGet from '@pages/mkt/activity/invitationCoupons/couponsGet'
import MyPrize from '@pages/mkt/activity/invitationCoupons/myPrize'
import InvitedMember from '@pages/mkt/activity/invitationCoupons/invitedMember'
import ConsumeRebate from '@pages/mkt/activity/consumeRebate'
import BindMobile from '@pages/mkt/activity/bindMobile'
import CardForActivity from '@pages/mkt/components/ActRelateCardModal'

// 抽奖活动
import LuckyList from '@pages/mkt/luckyDraw/list'
import LuckyDetail from '@pages/mkt/luckyDraw/detail'
import LuckyRecord from '@pages/mkt/luckyDraw/record'
import LuckyPrize from '@pages/mkt/luckyDraw/prize'

// 积分兑换
import RedeemList from '@pages/mkt/redeem/list'

// 团购商城
import GroupBuyList from '@pages/mkt/groupBuy/list'
import GroupBuyDetail from '@pages/mkt/groupBuy/detail'

// 活动预约
import ActivityReserveList from '@pages/mkt/activityReserve/list'
import ActivityReserveDetail from '@pages/mkt/activityReserve/detail'
import ActivityReserveBooking from '@pages/mkt/activityReserve/booking'
import ActivityReserveRecords from '@pages/mkt/activityReserve/records'
import ActivityReserveRecordDetail from '@pages/mkt/activityReserve/recordDetail'

// 评价
import Eval from '@pages/mkt/evaluate/eval'
import EvalDetail from '@pages/mkt/evaluate/eval/detail'

// 银行卡管理
import BankCardManage from '@pages/pay/bankCardManage'

// 游客页面
import Visit from '@pages/mkt/visit'

// 非手机端外壳
import PhoneCase from '@pages/phoneCase'

// 小程序跳转引导页
import JumpWx from '@pages/jumpWx'

// 发票
import MyInvoice from '@pages/myInvoice/invoice'
import MyInvoiceNot from '@pages/myInvoice/not'

// 语音服务
import VoiceService from '@pages/voice'

// 企业微信
import WeChatWork from '@pages/weChatWork'

// 排队
import Queue from '@pages/queue'

// 搜索
import Search from '@pages/search'

// 探索门店
import StoreDisplay from '@pages/storeDisplay'
import StoreDisplayList from '@pages/storeDisplay/list'
import StoreDisplayDetail from '@pages/storeDisplay/detail'

const Pc = lazy(() => import('@pages/status/pc'))
const GoScan = lazy(() => import('@pages/status/goScan'))
const NotWeixin = lazy(() => import('@pages/status/notWeixin'))
const System404 = lazy(() => import('@pages/status/system404'))
const SystemError = lazy(() => import('@pages/status/systemError'))
const SystemBusy = lazy(() => import('@pages/status/systemBusy'))
const NoStore = lazy(() => import('@pages/status/noStore'))
const NoMall = lazy(() => import('@pages/status/noMall'))
const NoStoreStatus = lazy(() => import('@pages/status/noStoreStatus'))
// 隐私权限授权
const AuthAgreement = lazy(() => import('@pages/authAgreement'))

const routerConfig: TRouter[] = [
  {
    // 首页
    path: '/home',
    pageName: 'pageName.home',
    component: Home,
  },
  {
    // 菜单
    path: '/phoneCase',
    pageName: 'pageName.menu',
    component: PhoneCase,
  },
  {
    // 菜单
    path: '/menu',
    pageName: 'pageName.menu',
    component: Menu,
  },
  {
    // 门店 targetType拓展属性，拼单 buyTogether
    path: '/store',
    pageName: 'pageName.chooseStore',
    component: Store
  },
  {
    // 城市选择
    path: '/storeCitys',
    pageName: 'pageName.chooseCity',
    component: StoreCitys
  },
  {
    // 拼单购物车
    path: '/buyTogetherCart',
    pageName: 'pageName.buyTogetherCart',
    component: BuyTogetherCart
  },
  {
    // 餐品详情
    path: '/product/:productNo/:scaleNo?/:targetType?/:targetNo?',
    pageName: 'pageName.menu',
    component: Detail
  },
  {
    // 套餐详情
    path: '/combo/:productNo/:scaleNo?/:targetType?/:targetNo?',
    pageName: 'pageName.menu',
    component: Detail
  },
  {
    // 购物车餐品详情
    path: '/detail/:productType/:pk/:productNo',
    pageName: 'pageName.menu',
    component: Detail
  },
  {
    // 口味详情
    path: '/modifier/:modifierGroupNo',
    pageName: 'modifier.name',
    component: Modifier
  },
  {
    // 广告页
    path: '/advert',
    pageName: 'advert.title',
    component: Advert
  },
  {
    // 广告页 品牌级
    path: '/advertBrand/:type?/:index?',
    pageName: 'advert.title',
    component: Advert
  },
  {
    /**
     * 推荐页 指定餐品推荐
     * type 类型
     * uid 唯一值
     * title 切换页面标题
    */
    path: '/recommend/:type/:uid/:title?',
    pageName: 'advert.recommend',
    component: Recommend
  },
  {
    // 结算页
    path: '/checkout',
    pageName: 'pageName.checkout',
    component: Checkout,
  },
  {
    // 结算页
    path: '/posCheckout',
    pageName: 'pageName.checkout',
    component: PosCheckout,
  },
  {
    // 拼单购物车页
    path: '/together',
    pageName: 'pageName.checkout',
    component: BuyTogetherCart,
  },
  {
    // 支付
    path: '/pay/:id',
    pageName: 'pageName.pay',
    component: Pay,
  },
  {
    path: '/payfail/:id?',
    pageName: 'pageName.payfail',
    component: Payfail
  },
  {
    path: '/posPayfail/:id?',
    pageName: 'pageName.payfail',
    component: PosPayfail
  },
  {
    path: '/paypalreturn/:id',
    pageName: 'pageName.return',
    component: PayPalReturn
  },
  {
    path: '/mergeqr/:paramSign',
    pageName: 'pageName.qrcodePay',
    component: MergeQr
  },
  {
    path: '/mergeqrv2/:paramSign',
    pageName: 'pageName.qrcodePay',
    component: MergeQrV2
  },
  { // 支付结果页
    path: '/result/:id?',
    pageName: 'pageName.payResult',
    component: Result,
  },
  {
    // 账单页
    path: '/bill/:id',
    pageName: 'pageName.payResult',
    component: Bill,
  },
  {
    // 订单
    path: '/orders/:pageLevel?',
    pageName: 'pageName.orders',
    component: Orders,
  },
  {
    // 申请退款
    path: '/refund/:ordersId',
    pageName: 'pageName.refund',
    component: Refund,
  },
  {
    // 退款详情
    path: '/refund/detail/:ordersId',
    pageName: 'pageName.refund',
    component: RefundDetail,
  },
  {
    // 拼单账单页
    path: '/billBuyTogether/:id',
    pageName: 'pageName.payResult',
    component: BillTogether,
  },
  {
    // 三方券核销
    path: '/thirdCoupon/:type?',
    pageName: 'pageName.thirdCoupon',
    component: ThirdCoupon,
  },
  /**
   * 商城
   */
  { // 手机商城
    path: '/mall',
    pageName: 'pageName.mall',
    component: Mall
  },
  { // 商城商品详情
    path: '/mproduct/:productNo/:groupBuyId?',
    pageName: 'pageName.mall',
    component: MallProduct,
  },
  { // 商城搜索
    path: '/msearch',
    pageName: 'pageName.search',
    component: MallSearch,
  },
  { // 商城结算页
    path: '/mcheckout',
    pageName: 'pageName.checkout',
    component: MallCheckout,
  },
  { // 商城收藏单
    path: '/mcollect',
    pageName: 'pageName.favorite',
    component: MallCollect,
  },
  { // 商城支付失败
    path: '/mpayfail/:id?',
    pageName: 'pageName.payfail',
    component: MallPayFail,
  },
  { // 商城授权过期
    path: '/noMall',
    pageName: 'pageName.mall',
    component: NoMall,
  },
  /**
   * 门店探索
   */
  {
    path: '/storeDisplay',
    pageName: 'pageName.storeDisplay',
    component: StoreDisplay,
    children: [
      {
        path: 'list/:cityName',
        pageName: 'pageName.storeList',
        component: StoreDisplayList,
      },
      {
        path: 'detail/:storeId',
        pageName: 'pageName.storeDetail',
        component: StoreDisplayDetail,
      },
    ]
  },
  /**
   * 排队点餐
   */
  {
    path: '/queue',
    pageName: 'pageName.queue',
    component: Queue,
  },
  { // 个人中心
    path: '/my',
    pageName: 'pageName.my',
    component: My,
    children: [
      {
        path: 'setting',
        pageName: 'pageName.setting',
        component: MySetting,
      },
      {
        path: 'couponGet',
        pageName: 'pageName.coupon',
        component: MyCouponGet,
      },
      {
        path: 'getCoupons/:activityId',
        pageName: 'pageName.coupon',
        component: CodeCoupons,
      },
      {
        path: 'othersBind',
        pageName: 'mkt.common.otherNum',
        component: MyOthersBind,
      },
      {
        path: 'language',
        pageName: 'mkt.setting.languageSelect',
        component: MyLanguage,
      },
      {
        path: 'resetPwd',
        pageName: 'mkt.member.resetPassword',
        component: MyResetPwd,
      },
      {
        path: 'address',
        pageName: 'mkt.common.shippingAddress',
        component: MyAddress,
      }
    ]
  },
  {
    path: '/myInvoice',
    pageName: 'pageName.myInvoice',
    component: MyInvoice,
    children: [
      {
        path: 'not',
        pageName: 'pageName.myInvoice',
        component: MyInvoiceNot,
      }
    ]
  },
  // 评价
  {
    path: '/eval',
    pageName: 'pageName.evaluate',
    component: null,
    children: [
      {
        path: ':orderNo',
        pageName: 'pageName.evaluate',
        component: Eval,
      },
      {
        path: 'detail/:orderNo',
        pageName: 'pageName.evaluate',
        component: EvalDetail,
      }
    ]
  },
  { // 绑定
    path: '/iBind/:bindType',
    pageName: 'pageName.binding',
    component: IBind,
  },
  { // 活动
    path: '/activity',
    pageName: 'pageName.coupon',
    component: null,
    children: [
      {
        path: 'codeCoupons/:activityId',
        pageName: 'pageName.coupon',
        component: CodeCoupons,
      },
      {
        path: 'wechatCoupons/:logId',
        pageName: 'pageName.coupon',
        component: WechatCoupons,
      },
      {
        path: 'couponsSend/:activityId',
        pageName: 'pageName.couponsSend',
        component: CouponsSend,
      },
      {
        path: 'couponsGet/:activityId',
        pageName: 'pageName.couponsSend',
        component: CouponsGet,
      },
      {
        path: 'myPrize/:activityId',
        pageName: 'pageName.couponsSend',
        component: MyPrize,
      },
      {
        path: 'invitedMember/:activityId',
        pageName: 'pageName.couponsSend',
        component: InvitedMember,
      },
      {
        path: 'consumeRebate/:activityId',
        pageName: 'pageName.consumeRebate',
        component: ConsumeRebate,
      },
      {
        path: 'bindMobile/:activityId',
        pageName: 'pageName.bindMobile',
        component: BindMobile
      },
      {
        path: 'card',
        pageName: 'pageName.card',
        component: CardForActivity
      }
    ]
  },
  { // 我的券
    path: '/iCoupon',
    pageName: 'pageName.coupon',
    component: Coupon,
    children: [
      {
        path: 'coupon/:type?',
        pageName: 'pageName.coupon',
        component: Coupon,
      },
      {
        path: 'record',
        pageName: 'mkt.coupon.couponRecord',
        component: CouponRecord,
      },
      {
        path: 'giftRecord',
        pageName: 'mkt.coupon.couponRecord',
        component: CouponGiftRecord,
      },
      {
        path: 'giftRecordDetail/:recordId',
        pageName: 'mkt.coupon.couponRecord',
        component: GiftRecordDetail,
      },
      {
        path: 'couponGetRecord',
        pageName: 'mkt.coupon.couponGetRecord',
        component: CouponGetRecord
      },
      {
        path: 'couponGive',
        pageName: 'pageName.coupon',
        component: CouponGive
      }
    ]
  },
  { // 我的会员卡
    path: '/iCard/:cardId?',
    pageName: 'pageName.card',
    component: MyCard,
    children: [
      {
        path: 'cardRecharge/:cardId',
        pageName: 'pageName.card',
        component: MyCardRecharge,
      },
      {
        path: 'cardOpen/:type/:cardId/:groupBuyId?',
        pageName: 'pageName.card',
        component: MyCardOpen,
      }
    ]
  },
  { // 我的礼品卡
    path: '/iGc',
    pageName: 'mkt.giftCard.myGiftCard',
    component: MyGiftCard,
    children: [
      {
        path: 'giftCard/:cardNumber',
        pageName: 'pageName.giftCard',
        component: MyGiftCardDetail,
      },
      {
        path: 'recharge/:cardId',
        pageName: 'mkt.giftCard.giftCardRecharge',
        component: MyGiftCardRecharge,
      },
      {
        path: 'giftRecord',
        pageName: 'mkt.giftCard.giftCardRecharge',
        component: MyGiftCardRecord,
      },
      {
        path: 'giftAvailable',
        pageName: 'mkt.giftCard.unavailableCard',
        component: MyGiftAvailable
      }
    ]
  },
  { // 我的券
    path: '/redeem/:cardId?',
    pageName: 'mkt.redeem.pointRedeem',
    component: RedeemList,
    children: [
      {
        path: 'detail/:recordId',
        pageName: 'mkt.redeem.pointRedeem',
        component: GiftRecordDetail,
      }
    ]
  },
  { // 我的券
    path: '/groupBuy',
    pageName: 'mkt.groupBuy.groupBuy2',
    component: GroupBuyList,
    children: [
      {
        path: 'detail/:productId',
        pageName: 'mkt.groupBuy.groupBuy2',
        component: GroupBuyDetail,
      }
    ]
  },
  { // 活动预约
    path: '/activityReserve',
    pageName: 'mkt.activityReserve.title',
    component: ActivityReserveList,
    children: [
      {
        path: 'detail/:activityId',
        pageName: 'mkt.activityReserve.detailTitle',
        component: ActivityReserveDetail,
      },
      {
        path: 'booking/:activityId',
        pageName: 'mkt.activityReserve.bookingTitle',
        component: ActivityReserveBooking,
      },
      {
        path: 'records',
        pageName: 'mkt.activityReserve.myReservations',
        component: ActivityReserveRecords,
      },
      {
        path: 'record/:bookingId',
        pageName: 'mkt.activityReserve.recordDetailTitle',
        component: ActivityReserveRecordDetail,
      }
    ]
  },
  { // 抽奖活动
    path: '/luckyDraw',
    pageName: 'pageName.activeList',
    component: LuckyList,
    children: [
      {
        path: 'detail/:activityId',
        pageName: 'pageName.activeList',
        component: LuckyDetail,
      },
      {
        path: 'record/:activityId',
        pageName: 'mkt.activity.myPrize',
        component: LuckyRecord
      },
      {
        path: 'prize/:activityId',
        pageName: 'mkt.pointCard.activeRewards',
        component: LuckyPrize
      }
    ]
  },
  { // 会员结果页面
    path: '/mktResult',
    pageName: 'order.recharge',
    component: null,
    children: [
      {
        path: 'success/:orderId',
        pageName: 'order.recharge',
        component: MktSuccResult,
      },
      {
        path: 'paySuccess/:orderId',
        pageName: 'order.recharge',
        component: PaySuccess,
      }
    ]
  },
  {
    path: '/iBc',
    pageName: 'pay.bankCardManage',
    component: BankCardManage,
  },
  {
    path: '/iRecord',
    pageName: 'pageName.my',
    component: null,
    children: [
      {
        path: 'flow/:type/:cardNo',
        pageName: 'mkt.record.consumRecords',
        component: RecordFlow,
      },
      {
        path: 'consum',
        pageName: 'mkt.record.personalConsumRecords',
        component: ConsumRecord,
      },
    ]
  },
  {
    path: '/giftCard/:pageLevel?',
    pageName: 'pageName.giftCard',
    component: GiftCard,
    children: [
      {
        path: 'buy/:cardId',
        pageName: 'pageName.giftCardDetail',
        component: GiftCardBuy,
      }
    ]
  },
  {
    path: '/jumpWx',
    pageName: 'pageName.jumpWx',
    component: JumpWx,
  },
  // AllGiftCard
  {
    path: '/allGiftCard',
    pageName: 'pageName.giftCard',
    component: AllGiftCard,
  },
  {
    path: '/pointCard',
    pageName: 'pageName.pointCard',
    component: PointCard,
    children: [
      {
        path: 'detail/:id',
        pageName: 'pageName.pointCard',
        component: PointCardDetail,
      }
    ]
  },
  {
    path: '/memberCard',
    pageName: 'pageName.card',
    component: MyCard,
    children: [
      {
        path: 'cardApply',
        pageName: 'pageName.card',
        component: MyCardApply
      }
    ]
  },
  {
    path: '/visit/:type?',
    pageName: 'pageName.Login',
    component: Visit
  },
  { // 隐私权限授权
    path: '/authAgreement',
    pageName: 'pageName.tips',
    component: AuthAgreement
  },
  { // 登录
    path: '/login',
    pageName: 'pageName.Login',
    component: Login,
    children: [
      {
        path: 'verify/:type/:account/:countryCode',
        pageName: 'pageName.forget',
        component: LoginVerify,
      },
      {
        path: 'password/:isReg/:type/:account/:countryCode',
        pageName: 'loginPassword',
        component: LoginPassword,
      }
    ]
  },
  { // 无门店
    path: '/noStore',
    pageName: '',
    component: NoStore,
  },
  { // 门店菜单提示(暂停接单)
    path: '/noStoreStatus/:type',
    pageName: '',
    component: NoStoreStatus,
  },
  { // 404
    path: '/404',
    pageName: '',
    component: System404,
  },
  { // 系统错误
    path: '/systemError',
    pageName: '',
    component: SystemError,
  },
  { // 系统繁忙
    path: '/systemBusy',
    pageName: '',
    component: SystemBusy,
  },
  { // 去扫码
    path: '/goScan',
    pageName: '',
    component: GoScan,
  },
  { // 国内非微信
    path: '/notWeixin',
    pageName: '',
    component: NotWeixin,
  },
  { // PC页面
    path: '/pc',
    pageName: '',
    component: Pc,
  },
  { // 语音服务
    path: '/voiceService',
    pageName: 'pageName.voiceService',
    component: VoiceService,
  },
  { // 企业微信
    path: '/weChatWork/:adPositionType?',
    pageName: 'pageName.weChatWork',
    component: WeChatWork,
  },
  { // 语音服务 type 类型，mall 是商城
    path: '/search/:type?',
    pageName: 'pageName.search',
    component: Search,
  },
]

export {
  routerConfig
}
